module.exports = __webpack_public_path__ + "img/individuelles_eheringe_button.81ab1976.jpg";